import api from "./apiClient";

export async function getTags() {
	const response = await api.get("/tags");
	return response.json();
}

export async function getUserTags(userId) {
	const response = await api.get(`/tags/user/${userId}`);
	return response.json();
}

export async function getTag(id) {
	const response = await api.get(`/tags/${id}`);
	return response.json();
}

export async function getTagBuilderConfiguration(id) {
	const response = await api.get(`/tags/${id}/configuration/builder`);
	return response.json();
}

export async function getTagMetrics(id, amsFlavor, modelingEnabled) {
	const response = await api.get(`/tags/${id}/metrics`, {
		headers: {
			'UI-Version': 2,
			'AMS-Flavor': amsFlavor,
			'Modeling-Enabled': modelingEnabled ? 1 : 0
		}
	});
	return response.json();
}

/** Daily page views (page + amp) and unique users, 30 complete days ending yesterday (ASB-3567). */
export async function getTagPageViewTrends(id) {
	const response = await api.get(`/tags/${id}/trends/page-views`);
	return response.json();
}

export async function getTagByPublisher(e) {
	const publisher_id = e.value;
	const response = await api.get(`/tags/publisher/${publisher_id}`);
	return response.json();
}

export async function getDomainsByTag(tagId) {
	const response = await api.get(`/tags/${tagId}/domains`);
	return response.json();
}

export async function getKeywordsByTag(tagId, query) {
	const payload = { keyword: query };
	const response = await api.post(`/tags/${tagId}/search/keywords`, payload);
	return response.json();
}

export async function getTaxonomyByTag(tagId, query) {
	const payload = { keyword: query };
	const response = await api.post(`/tags/${tagId}/search/taxonomy`, payload);
	return response.json();
}

export async function getCustomDataByTag(tagId, type, field, query, event) {
	const payload = { type: type, field: field, value: query, event: event };
	const response = await api.post(`/tags/${tagId}/search/custom`, payload);
	return response.json();
}

export async function getGAMEntitiesByTag(tagId, type, query) {
	const payload = { type: type, query: query };
	const response = await api.post(`/tags/${tagId}/search/integrations/gam`, payload);
	return response.json();
}

export async function addTag(payload) {
	const response = await api.post("/tags", payload);
	return response;
}

export async function updateTag(payload, tagId) {
	const response = await api.put(`/tags/${tagId}`, payload);
	return response;
}

export function bundlePayload(tagName, publisherName, subdomain, discoveryEmbedUrl, performanceEmbedUrl, campaignInsightsEmbedUrl, audienceInsightsEmbedUrl, pmpProfileEmbedUrl, sameOrigin) {
	return {
		data: [
			{
				name: tagName,
				publisher_name: publisherName,
				subdomain: subdomain,
				dashboards: {
					discovery: discoveryEmbedUrl ? discoveryEmbedUrl : "/404.html",
					performance: performanceEmbedUrl ? performanceEmbedUrl : "/404.html",
					campaignInsights: campaignInsightsEmbedUrl ? campaignInsightsEmbedUrl : "/404.html",
					audienceInsights: audienceInsightsEmbedUrl ? audienceInsightsEmbedUrl : "/404.html",
					pmpProfile: pmpProfileEmbedUrl ? pmpProfileEmbedUrl : "/404.html",
					sameOrigin: sameOrigin ? sameOrigin : false
				}
			},
		],
	}
}

export async function updateTagIntegrations(payload, tagId) {
	const response = await api.put(`/tags/${tagId}/integrations/gam`, payload);
	return response;
}

export async function updateTagXandrIntegration(payload, tagId) {
	const response = await api.put(`/tags/${tagId}/integrations/xandr`, payload);
	return response;
}

export async function removeTagXandrIntegration(tagId) {
	const response = await api.delete(`/tags/${tagId}/integrations/xandr`);
	return response;
}

export async function updateTagEquativIntegration(payload, tagId) {
	const response = await api.put(`/tags/${tagId}/integrations/equativ`, payload);
	return response;
}

export async function deleteTagEquativIntegration(tagId) {
	const response = await api.delete(`/tags/${tagId}/integrations/equativ`);
	return response;
}

export async function updateTagOpenxIntegration(payload, tagId) {
	const response = await api.put(`/tags/${tagId}/integrations/openx`, payload);
	return response;
}

export async function deleteTagOpenxIntegration(tagId) {
	const response = await api.delete(`/tags/${tagId}/integrations/openx`);
	return response;
}
export async function updateTagIxIntegration(payload, tagId) {
	const response = await api.put(`/tags/${tagId}/integrations/ix`, payload);
	return response;
}

// Not a plain disable: the API starts a purge of every user ArcSpan sent to
// Index Exchange (ASB-3371). The Settings view confirms that before calling.
export async function deleteTagIxIntegration(tagId) {
	const response = await api.delete(`/tags/${tagId}/integrations/ix`);
	return response;
}
